module.exports = __webpack_public_path__ + "6cc4163dc930ec1110e0321e4a710a2b.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/gif-hero-mac.png
// module id = 631
// module chunks = 0